import { defineMessages } from "react-intl";

const baseId = "t.components.TextInputField.Error.";

export default defineMessages({
  unauthorized: {
    id: `${baseId}unauthorized`,
    defaultMessage: "username or password wrong",
  },
  unknown: {
    id: `${baseId}unknown`,
    defaultMessage: "unknown error!",
  },
  serviceUnavailable: {
    id: `${baseId}ServiceUnavailable`,
    defaultMessage: "Service Unavailable",
  },
});
